export default __webpack_public_path__ + "media/images/plans/passenger-20581dbc73e6c214a7f85f8776292919.png";